<template>
  <div class="page">
    <common-header />
    <div class="container">
      <p class="title __fs-24">{{detailData.title}}</p>
      <div class="label __cor-8 __flex __flex-vc">
        <p class="time">时间：{{detailData.modifyTime | formatTime('YYYY-MM-DD')}}</p>
        <p v-if="detailData.source" class="source">来源：{{detailData.source}}</p>
      </div>
      <div class="summary" v-html="detailData.content"></div>
    </div>
  </div>
</template>

<script>
import CommonHeader from '@/views/layout/common-back'
import { story, common, news } from '@/agent'
import Dict from '@/core/dict'
export default {
  components: {
    'common-header': CommonHeader
  },
  data () {
    return {
      id: '',
      detailData: {},
      srcImg: 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/platform/common/richtext/image/202105185ab9051a068d4e8f8336a1a1f83b3c60.jpg'
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    if (this.type === Dict.pageType.memory) {
      this.FindById()
    } else if (this.type === Dict.pageType.advertisement) {
      this.bannerFindById()
    } else if (this.type === Dict.pageType.hotNews) {
      this.newsDetail()
    }
  },
  methods: {
    // 事记详情
    async FindById () {
      const result = await story.findById(this.id)
      if (result.code === 100) {
        this.detailData = result.data
      }
    },
    // 轮播图详情
    async bannerFindById () {
      const result = await common.bannerFindById(this.id)
      if (result.code === 100) {
        this.detailData = result.data
        this.detailData.title = this.detailData.name
        this.detailData.content = this.detailData.expatiate
      }
    },
    // 资讯详情
    async newsDetail () {
      console.log('123')
      const result = await news.findById(this.id)
      if (result.code === 100) {
        this.detailData = result.data
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
.container {
  padding: 0 20px 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.title {
  padding: 47px 0 25px;
  line-height: 36px;
  display: table;
  margin: 0 auto;
}
.label {
  align-items: start;
  .time {
    white-space: nowrap;
  }
  .source {
    margin-left: 21px;
    word-break:break-all;
  }
}
.summary {
  margin: 48px auto 35px;
  text-indent: 2em;
  text-align: justify;
  line-height: 24px;
  font-size: 16px;
  /deep/ img {
    width: 100%;
    display: block;
  }
}
</style>
